import epdLocalLogo from "../img/EPD-logo.png";
import oekoTexLocalLogo from "../img/oekotex.png";
import alternativePolymerLocalLogoEn from "../img/poliymer-alternative.png"
import alternativePolymerLocalLogoEs from "../img/polimero-alternativo.png"

export const ATTRS_LOCAL_LOGOS = {
  epd: {
    en: epdLocalLogo,
    es: epdLocalLogo,
  },
  oekoTex: {
    en: oekoTexLocalLogo,
    es: oekoTexLocalLogo,
  },
  alternativePolymer: {
    en: alternativePolymerLocalLogoEn,
    es: alternativePolymerLocalLogoEs,
  },
}